export default __webpack_public_path__ + "static/media/Hair_1_M_C1.44f72b77.svg";